// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = (role) => {
  const userRole = role?.role;
  const filteredMenuItem = menuItem.items.filter((item) => item.children?.some((child) => child.allowedRoles?.includes(role.role)));

  // const filteredMenuItem = menuItem.items
  //   .map((item) => ({
  //     ...item,
  //     children: item.children?.filter((child) => child.allowedRoles?.includes(userRole))
  //   }))
  //   .filter((item) => item.children?.length > 0);
  console.log("/?", filteredMenuItem);

  const navItems = filteredMenuItem?.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default MenuList;
